import App from '../App';
import { MoveSpeed, Person, RotationDirections } from './Person';
import { GamepadManager, Xbox360Pad, Xbox360Button, StickValues, GenericPad, PoseEnabledController, Gamepad as BJS_Gamepad } from '@babylonjs/core/Gamepads';

import { ListenableEvent } from '@egr/wcf/modules/utils';

export class Gamepad {
    public readonly eventHeightChanged: ListenableEvent<void, Gamepad>;
    private gamepadManager: GamepadManager;

    constructor(public readonly app: App) {
        this.eventHeightChanged = new ListenableEvent<void, Gamepad>(this);
        this.gamepadManager = new GamepadManager();
        this.gamepadManager.onGamepadConnectedObservable.add((gamepad: BJS_Gamepad) => {
            // Handle gamepad types
            if (gamepad instanceof Xbox360Pad) {
                // Xbox button down/up events
                gamepad.onButtonDownObservable.add((button: Xbox360Button) => {
                    if (button === Xbox360Button.Y) {
                        Person.toggleHeight(this.app.coreApp.viewer.view);
                        this.eventHeightChanged.trigger();
                    }
                });

                gamepad.onButtonUpObservable.add(() => { /* for further use */ });

                // Stick events
                gamepad.onleftstickchanged(() => {
                    const moveSpeed: MoveSpeed = this.getSpeedByPoint(gamepad.leftStick);
                    if (moveSpeed !== 'idle') {
                        const moveAngle: number = this.getAngleByPoint(gamepad.leftStick);
                        Person.move(this.app.coreApp.viewer.view, moveAngle, moveSpeed);
                    }
                });

                gamepad.onrightstickchanged((values: StickValues) => {
                    const direction: RotationDirections = this.getRotationDirection(values);
                    if (direction !== 'idle') {
                        Person.rotate(this.app.coreApp.viewer.view, direction);
                    }
                });
            }
            if (gamepad instanceof GenericPad) {
                // Generic button down/up events
                gamepad.onButtonDownObservable.add(() => { /* for further use */ });
                gamepad.onButtonUpObservable.add(() => { /* for further use */ });

                // Stick events
                gamepad.onleftstickchanged(() => {
                    const moveSpeed: MoveSpeed = this.getSpeedByPoint(gamepad.leftStick);
                    if (moveSpeed !== 'idle') {
                        const moveAngle: number = this.getAngleByPoint(gamepad.leftStick);
                        Person.move(this.app.coreApp.viewer.view, moveAngle, moveSpeed);
                    }
                });
            }
            if (gamepad instanceof PoseEnabledController) {
                // Stick events
                gamepad.onleftstickchanged(() => {
                    const moveSpeed: MoveSpeed = this.getSpeedByPoint(gamepad.leftStick);
                    if (moveSpeed !== 'idle') {
                        const moveAngle: number = this.getAngleByPoint(gamepad.leftStick);
                        Person.move(this.app.coreApp.viewer.view, moveAngle, moveSpeed);
                    }
                });
            }
        });

        this.gamepadManager.onGamepadDisconnectedObservable.add(() => { /* for further use */ });

        this.app.coreApp.model.scene.registerBeforeRender(() => {
            // Check a gamepad's current state
            const gamepad: BJS_Gamepad = this.gamepadManager.gamepads[0];
            if (gamepad && gamepad instanceof Xbox360Pad) {
                if (gamepad.buttonA) {
                    // sphere.position.y += 0.05;
                    // console.log('Button A');
                }
                const moveSpeed: MoveSpeed = this.getSpeedByPoint(gamepad.leftStick);
                if (moveSpeed !== 'idle') {
                    const moveAngle: number = this.getAngleByPoint(gamepad.leftStick);
                    Person.move(this.app.coreApp.viewer.view, moveAngle, moveSpeed);
                }
                const rotationDirection: RotationDirections = this.getRotationDirection(gamepad.rightStick);
                if (rotationDirection !== 'idle') {
                    Person.rotate(this.app.coreApp.viewer.view, rotationDirection);
                }
            }
        });
    }

    protected getRotationDirection(values: StickValues): RotationDirections {
        if (Math.abs(values.x) < Math.abs(values.y)) { // front or back
            if (values.y >= -0.1 && values.y <= 0.1) {
                return 'idle';
            }
            if (values.y < -0.1) {
                return 'top';
            }
            return 'down';
        }
        // left or right
        if (values.x >= -0.1 && values.x <= 0.1) {
            return 'idle';
        }
        if (values.x < -0.1) {
            return 'left';
        }
        return 'right';
    }

    private getAngleByPoint(values: StickValues): number {
        let angle: number = Math.atan2(values.x, values.y) * 180 / Math.PI;
        angle = Math.floor(180 - angle);
        if (angle > 180) {
            angle = angle - 360;
        }
        return angle;
    }

    private getSpeedByPoint(values: StickValues): MoveSpeed {
        const speed: number = Math.sqrt(Math.pow(values.x, 2) + Math.pow(values.y, 2));
        if (speed < 0.1) {
            return 'idle';
        }
        if (speed < 0.5) {
            return 'low';
        }
        if (speed < 1) {
            return 'mid';
        }
        return 'high';
    }
}